import React, { FunctionComponent } from 'react';
import { Container, Column, Row } from '@iag-packages/chroma-react/lib/layouts';
import Media from 'react-media';

import { PaymentFrequency, Premium, Campaign } from 'scenes/common/types';
import { SCREEN } from 'scenes/common/types/screen';
import QuotePriceCard from 'scenes/common/components/QuoteInformation/QuotePriceCards/QuotePriceCard';
import MarketingCampaign from 'scenes/common/components/MarketingCampaign/MarketingCampaign';

import { PreviousButton } from './PreviousButton';
import YouAreCovered from './YouAreCovered';

export const Header: FunctionComponent<{
  onPrevious: () => void;
  quoteNumber: string;
  coverType: string;
  premium: Premium;
  campaign?: Campaign;
  selectedPaymentFrequency: PaymentFrequency;
  hasPreviousButton: boolean;
  hasQuoteInformation: boolean;
  showMarketingCampaign: boolean;
  showPaymentConfirmationHeader: boolean;
  ImageYouAreCovered: FunctionComponent;
  firstInstalment: string;
  followingMonths: string;
}> = ({
  onPrevious,
  quoteNumber,
  coverType,
  premium: { price, annualPrice, monthlyInstalment },
  campaign,
  selectedPaymentFrequency,
  hasPreviousButton,
  hasQuoteInformation,
  showMarketingCampaign,
  showPaymentConfirmationHeader,
  ImageYouAreCovered,
  firstInstalment,
  followingMonths,
}) => (
  <>
    <Media query={{ maxWidth: SCREEN.LARGE - 1 }}>
      {(sidebarHidden: boolean) => (
        <>
          {sidebarHidden && hasQuoteInformation && (
            <QuotePriceCard
              selectedPaymentFrequency={selectedPaymentFrequency}
              price={price}
              annualPrice={annualPrice}
              coverType={coverType}
              monthlyInstalment={monthlyInstalment}
              firstInstalment={firstInstalment}
              followingMonths={followingMonths}
            />
          )}
          {sidebarHidden && showMarketingCampaign && (
            <MarketingCampaign
              headerDisplay
              quoteNumber={quoteNumber}
              campaign={campaign}
            />
          )}
        </>
      )}
    </Media>
    {showPaymentConfirmationHeader && (
      <YouAreCovered Image={() => <ImageYouAreCovered />} />
    )}
    <Container>
      <Row>
        <Column xs={12} md={6} mdOffset={3}>
          <PreviousButton
            onPrevious={onPrevious}
            hasPreviousButton={hasPreviousButton}
          />
        </Column>
      </Row>
    </Container>
  </>
);

export default Header;
